import { Component, OnInit, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { SavedSearchStore } from '../services/saved-search/saved-search.store';
import { SavedSearch } from 'src/app/models/advanced-search-extended-models/saved-search/saved-search';
import { AuthService } from '../services/user-services/auth.service';
import { FormControl, FormGroup } from '@angular/forms';
import { AdvancedSearchStore } from '../services/advanced-search/advanced-search.store';
import { AdvancedSearchService } from '../services/advanced-search/advanced-search.service';
import { NgxValidators } from 'src/app/models/Helpers/ngxValidators';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-search-panel',
  templateUrl: './search-panel.component.html',
  styleUrls: ['./search-panel.component.scss']
})
export class SearchPanelComponent implements OnInit {

  advancedSearchActiveClass = 'advanced-search-active';

  selectedUserSearch: SavedSearch;
  selectedPredefinedSearch: SavedSearch;
  reactiveForm: FormGroup;
  filteredOptions: Observable<string[]>;
  options: string[];
  isGuest = false;

  constructor(
    private renderer: Renderer2,
    public savedSearchStore: SavedSearchStore,
    public searchStore: AdvancedSearchStore,
    private searchService: AdvancedSearchService,
    private userService: AuthService,
    public authService: AuthService,
    private router: Router
  ) { }

  ngOnInit(): void {
      this.reactiveForm = new FormGroup({
        isin: new FormControl('')
      });

      if (!this.searchStore.autocompleteValues) {
        this.searchService.getIsinList()
        .then(() => {
          this.reactiveForm.get('isin').setValidators(NgxValidators.isinExists(Object.keys(this.searchStore?.autocompleteValues)));
          this.listenToUserInput();
        });
      } else {
        this.listenToUserInput();
        this.reactiveForm.get('isin').setValidators(NgxValidators.isinExists(Object.keys(this.searchStore?.autocompleteValues)));
      }

      this.router.onSameUrlNavigation = 'reload';
  }

  hidePanel() {
    this.renderer.removeClass(document.body, this.advancedSearchActiveClass);
  }

  listenToUserInput() {
    this.filteredOptions = this.reactiveForm.get('isin').valueChanges
      .pipe(
        startWith(''),
        map(isin => isin?.length >= 1 ? this.search(isin) : this.options = [])
      );
  }

  search(isin: string): string[] {
    const filterValue = isin.toLowerCase().replace(/\s+/g, '');
    this.options = Object.keys(this.searchStore.autocompleteValues)
      .filter(option => option.toLowerCase().includes(filterValue))
      .slice(0, 20);
    return this.options;
  }

  displayFn(record: string): string {
    return record ? record : '';
  }

  goToDetaglioIsin() {
    let isin = this.reactiveForm.get('isin').value;
    // console.log(isin);
    this.userService.userManager.getUser().then(
      user => {
        this.isGuest = user?.profile?.role === 'CedLabGuest' ? true : false;
        if (this.isGuest) {
        isin = 'XS0993403558';
      }
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate(['/menu/scheda-certificato'], { queryParams: { isin} });
    }
    );

  }

  searchFromSavedSearch(search: SavedSearch) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigateByUrl('/menu/ricerca-avanzata', { state: search});
  }
}
